// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__LuSu9","title":"ClientInsurance_title__3FyGy","itemText":"ClientInsurance_itemText__mpHGU"};